/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { BaseCommentBaseWithExtendedReplies } from './BaseCommentBaseWithExtendedReplies';
import { InlineFeedbackExtra } from './InlineFeedbackExtra';
const InlineFeedbackCommentBaseWithExtendedRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(BaseCommentBaseWithExtendedReplies, InlineFeedbackExtra);
export class InlineFeedbackCommentBaseWithExtendedReplies extends InlineFeedbackExtra {
    static decode(input) {
        return InlineFeedbackCommentBaseWithExtendedRepliesParser.decode(input).map(res => new InlineFeedbackCommentBaseWithExtendedReplies(res));
    }
    static unsafeDecode(input) {
        return InlineFeedbackCommentBaseWithExtendedReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineFeedbackCommentBaseWithExtendedRepliesParser.encode(data);
    }
    static schema() {
        return InlineFeedbackCommentBaseWithExtendedRepliesParser.schema();
    }
}
